import React, { useEffect, useState } from "react";
import DropMenu from "./DropMenu";
import { data, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  Badge,
  Avatar,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import { ReactComponent as NotificationIcon } from "./Notification24.svg";

import {
  BsPersonCircle,
  BsFillGearFill,
  BsBoxArrowInLeft,
  BsBellFill,
  BsEnvelopeFill,
  BsList,
  BsPaletteFill,
  BsCircleHalf
} from "react-icons/bs";
import SubMenus from "../pages/extra/SubMenus";
import { Fa500Px, FaSignOutAlt } from "react-icons/fa";
import { FaUser } from "react-icons/fa6";
import { CHATALL, MESSAGEREAD } from "../services/actions";
import { ReactComponent as LogoutIcon } from "../assets/icons/profile/Logout_Black.svg";
import { ReactComponent as ProfileIcon } from "../assets/icons/profile/Profile_Black.svg";
import DNToggle from "./DNToggle";



export default function MyToolBar({
  user,
  onToggled,
  onLogout,
  appName,
  logo,
  logosm,
  logoyw
}) {
  const dispatch = useDispatch();
  const menuRight = React.useRef(null);
  const navigate = useNavigate();
  const chatallState = useSelector((state) => state?.chatallState);
  const [messages, setMessages] = React.useState([]);
  const [mailOpen, setMailOpen] = React.useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const items = [
    {
      icon: (
        <Avatar
          src={user?.avatar}
          alt={user?.first_name}
          sx={{ cursor: "pointer", width: 18, height: 18, fontSize: "6px" }}
        >
          <Typography className="input-label" fontSize={11}>
            {user?.first_name?.slice(0, 2)?.toUpperCase()}
          </Typography>
        </Avatar>
      ),
      label: (user?.first_name || user?.username || '')?.toUpperCase(),

      command: () => { },
    },
    {
      label: <Typography className="input-label" sx={{ px: 1 }}>Profile</Typography>,
      icon: <Box className="icon-filled"><ProfileIcon fontSize="1em" color="green" /></Box>,
      command: () => navigate("/profile/"),
    },
    // {
    //   label: <Typography className="input-label" sx={{ px: 1 }}>Settings</Typography>,
    //   icon: <BsFillGearFill fontSize="1em" color="green" />,
    //   command: () => navigate("/settings/"),
    // },
    {
      label: <Typography className="input-label" sx={{ px: 1 }}>Logout</Typography>,
      icon: <Box className="icon-filled"><LogoutIcon fontSize="1em" color="red" /></Box>,
      command: () => onLogout?.(),
    },
  ];

  const changeTheme = (newColor) => {
    const className = "card-bg"; // existing class name

    const styleSheet = document.styleSheets[0];
    const rules = styleSheet.cssRules || styleSheet.rules;

    // Search for the rule by class name
    let ruleIndex = -1;
    for (let i = 0; i < rules.length; i++) {
      if (rules[i].selectorText === `.${className}`) {
        ruleIndex = i;
        break;
      }
    }

    const newStyle = `.${className} { background-color: ${newColor}; }`;

    if (ruleIndex !== -1) {
      // Rule exists — remove it and insert updated version
      styleSheet.deleteRule(ruleIndex);
      styleSheet.insertRule(newStyle, ruleIndex);
    } else {
      // Rule doesn't exist — just insert it
      styleSheet.insertRule(newStyle, styleSheet.cssRules.length);
    }
  };


  useEffect(() => {
    if (!chatallState?.data) return;

    let all = Array.isArray(chatallState.data)
      ? chatallState.data
      : [chatallState.data];

    // 1. Unread CHAT messages (for the mail icon)
    let unreadChat = all.filter(
      (m) =>
        m.message_type === "chat" &&
        m.recipient === user?.id &&
        m.read === false
    );

    // 2. ALL NOTIFICATIONS for this user
    let notifications = all.filter(
      (m) =>
        m.message_type === "notification" &&
        m.recipient === user?.id
    );

    // 3. Unread NOTIFICATIONS → Bell icon count
    let unreadNotifications = notifications.filter((m) => m.read === false);

    // Update states
    setMessages(notifications);
    setUnreadCount(unreadNotifications.length);

    setMailOpen(unreadChat.length > 0);

  }, [chatallState.data]);


  const handleBellClick = () => {
    setUnreadCount(0)
    // dispatch({
    //   type: `${MESSAGEREAD}_GET`,
    //   payload: `message_read/0/${user?.id}/notification`,
    // });
  };

  return (
    <Box
      className="ps-toolbar card-bg"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        py: 1.3,
        width: "100%",
        position: "fixed",
        top: 0,
        zIndex: 1000,
        px: 3,
        height: 60
      }}
    >
      {/* Left - Toggle and Logo */}

      <Box sx={{ display: { sm: "block", md: "none", cursor: "pointer" }, width: 48 }} onClick={() => document.getElementById("side-bar").classList.toggle("show-menu")}>
        <BsList size={24} />
      </Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ display: { xs: "none", sm: "block" } }}>
        <img className="changable-logo-1" src={logo} alt="logo" style={{ height: 35 }} />
        <img className="changable-logo-2" src={logoyw} alt="logo" style={{ height: 35 }} />

      </Stack>
      <Typography className="black title-sm" sx={{ fontWeight: 600, fontSize: 20, display: { xs: "none", sm: "block" }, whiteSpace: "nowrap", px: 3 }}><label>Hi, {user?.first_name}</label></Typography>

      <Box display="flex" alignItems="center" justifyContent="center" width={1}>
        <Typography className="title-lg dark-gray" sx={{ minWidth: 120, display: { xs: "none", sm: "block" } }}>
          {appName}
        </Typography>
        <Typography component={'label'} sx={{ display: { sm: "block", md: "none" } }}>
          <img src={logosm} alt="logo" style={{ height: 35 }} />
        </Typography>

      </Box>

      {/* Right - Icons and User Menu */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{
          cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: 600,
          fontSize: 18,
          '&:hover': { color: '#ffcc33', }
        }} onClick={() => {
          navigate('/control-center/')
        }}>Control center</Box>
        <Box sx={{
          height: 16, '&:hover': {
            color: '#ffcc33'
          }
        }} >
          <DNToggle />
          {/* <BsCircleHalf title="Change color mode" className="bgmode-icon" fontSize={16} onClick={(e) => {
            let body = document.getElementsByTagName("body")[0]
            if (body.classList.contains("dark")) {
              localStorage.selectedTheme = ""
              body.classList.remove("dark")
              e.target.title = "White Mode"
            } else {
              body.classList.add("dark")
              localStorage.selectedTheme = "dark"
              e.target.title = "Dark Mode"
            }
          }} /> */}
        </Box>
        <SubMenus
          icon={
            <Box onClick={handleBellClick} sx={{ cursor: "pointer" }}>
              {unreadCount > 0 ? (
                <Badge sx={{
                  height: 16, height: 16, '&:hover': {
                    color: '#ffcc33'
                  }
                }} badgeContent={unreadCount} color="primary">
                  {/* <BsBellFill size={16} title="Notification" /> */}
                  <NotificationIcon fontSize={16} />
                </Badge>
              ) : (
                <Box sx={{
                  height: 16, '&:hover': {
                    color: '#ffcc33'
                  }
                }} >
                  {/* <BsBellFill size={16} title="Notification" /> */}
                  <NotificationIcon fontSize={16} />
                </Box>
              )}
            </Box>
          }
        >
          {/* Popup Content */}
          <Box sx={{ p: 1, width: 260 }}>
            <Typography fontWeight={600} sx={{ mb: 1 }}>
              Notifications
            </Typography>

            <Box
              sx={{
                maxHeight: 200,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {messages.length === 0 && (
                <Typography sx={{ fontSize: 12, color: "gray" }}>
                  No notifications yet
                </Typography>
              )}

              {messages.map((msg, i) => (
                <Box
                  key={i}
                  sx={{
                    p: 1,
                    bgcolor: "#f5f5f5",
                    borderRadius: 1,
                    fontSize: 13,
                  }}
                >
                  {msg.content}
                </Box>
              ))}
            </Box>
          </Box>
        </SubMenus>
        <Box sx={{
          height: 20, '&:hover': {
            color: '#ffcc33'
          }
        }}>
          <Badge
            variant={mailOpen ? "dot" : "standard"}
            color="error"
          // onClick={() => navigate("/messages")}
          >
            <BsEnvelopeFill size={16} title="Messages" />
          </Badge>
        </Box>
        <Box display={'flex'} gap={0.5}>
          <Typography
            className="input-label"
            sx={{
              textTransform: 'capitalize',
              fontWeight: 500, fontSize: 16,
              display: { xs: "none", sm: "block" },
              textWrap: 'nowrap'
            }}>
            {user?.first_name}
          </Typography>
          <Box sx={{ position: "relative" }}>
            <DropMenu
              model={items}
              popup
              icon={
                <Avatar
                  src={user?.avatar}
                  alt={user?.first_name}
                  sx={{ cursor: "pointer", width: 28, height: 28, }}
                >
                  <Typography fontSize={16} sx={{ fontWeight: 500 }}>
                    {user?.first_name?.slice(0, 2)?.toUpperCase()}
                  </Typography>
                </Avatar>
              }
            />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
